import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  MenuItem,
  Menu,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useFirebase } from "../../Firebase/FirebaseContext";
import { AccountCircle, MoreVert } from "@material-ui/icons";
import { signOut } from "firebase/auth";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import LeftMenu from "./LeftMenu";
// Les pastilles « Nouveau » suivent le compte et non le poste (retour du
// 04/09) : c'est ici qu'on sait qui est connecte.
import { brancherCompte } from "../../Utils/nouveautes";
import MenuIcon from "@material-ui/icons/Menu";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { useEffect } from "react";
import { FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import { Select } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    backgroundColor: "#FFFFFF",
    color: theme.palette.text.primary,
  },
  toolbar: {
    minHeight: 70,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "11",
    },
  },
  logoButton: {
    textTransform: "none",
    marginRight: theme.spacing(3),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  title: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: theme.palette.primary.main,
    letterSpacing: "0.5px",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  formControl: {
    margin: theme.spacing(0, 2),
    minWidth: 180,
    "& .MuiSelect-select": {
      color: theme.palette.text.primary,
      fontWeight: 500,
      fontSize: "0.95rem",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: theme.palette.divider,
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: theme.palette.primary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.primary.main,
    },
  },
  accountButton: {
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "11",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuPaper: {
    marginTop: theme.spacing(1),
    borderRadius: 12,
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  },
  menuItem: {
    padding: theme.spacing(1.5, 2),
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "11",
      color: theme.palette.primary.main,
    },
  },
}));

export default function Header() {
  const { firebase } = useFirebase();
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(false);
  const [salles, setSalles] = useState([]);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [selectedSalle, setSelectedSalle] = useState(""); // État pour la salle sélectionnée

  useEffect(() => {
    const q = query(
      collection(firebase.db, "laboratories"),
      where("structure", "==", localStorage.getItem("structure"))
    );

    // Exécutez la requête et récupérez les résultats
    getDocs(q)
      .then((querySnapshot) => {
        let temp = [];
        querySnapshot.forEach((doc) => {
          temp.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setSalles(temp);
        if (temp.length > 0) {
          let userLaboratory = localStorage.getItem("laboratory");
          let current = localStorage.getItem("currentLab");

          // Si currentLab n'existe pas (première connexion)
          if (!current) {
            // Utiliser le laboratoire d'origine s'il existe
            if (
              userLaboratory &&
              temp.some((lab) => lab.id === userLaboratory)
            ) {
              setSelectedSalle(userLaboratory);
              localStorage.setItem("currentLab", userLaboratory);
            } else {
              // Sinon utiliser le premier laboratoire
              setSelectedSalle(temp[0].id);
              localStorage.setItem("currentLab", temp[0].id);
            }
          } else {
            // Si currentLab existe déjà, on le respecte (pour permettre le changement de labo)
            if (temp.some((lab) => lab.id === current)) {
              setSelectedSalle(current);
            } else {
              // Si le laboratoire actuel n'est plus disponible
              setSelectedSalle(temp[0].id);
              localStorage.setItem("currentLab", temp[0].id);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des documents :", error);
      });
  }, []);

  // Retour du 04/09 : « les pastilles devraient plutot etre affichees par
  // utilisateurs ». On branche le compte connecte sur le registre des
  // nouveautes. Le document `users/{email}` est celui que le reste du
  // back-office utilise deja pour le profil.
  useEffect(() => {
    let debrancher = null;
    // On attend que l'authentification ait tranche : au premier rendu,
    // currentUser est encore nul et on brancherait sur personne.
    const arreterEcoute = onAuthStateChanged(getAuth(), (utilisateur) => {
      if (debrancher) { debrancher(); debrancher = null; }
      if (!utilisateur?.email) return;
      const ref = doc(firebase.db, "users", utilisateur.email);
      debrancher = brancherCompte({
        lire: async () => {
          const snap = await getDoc(ref);
          return snap.exists() ? snap.data().nouveautesVues || [] : [];
        },
        ecrire: (liste) => setDoc(ref, { nouveautesVues: liste }, { merge: true }),
      });
    });
    return () => {
      arreterEcoute();
      if (debrancher) debrancher();
    };
  }, [firebase]);

  const handleSalleChange = (event) => {
    setSelectedSalle(event.target.value);
    localStorage.setItem("currentLab", event.target.value);
    window.location.reload();
    // Vous pouvez effectuer des actions supplémentaires ici en fonction de la salle sélectionnée
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const logout = () => {
    signOut(firebase.auth)
      .then(() => {
        localStorage.clear();
        history.push("/login");
        console.log("Déconnexion du compte");
      })
      .catch((e) => {
        console.log("Erreur lors de la déconnexion");
      });
  };

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        className: classes.menuPaper,
      }}
    >
      <MenuItem
        className={classes.menuItem}
        onClick={() => {
          onAuthStateChanged(getAuth(), (user) => {
            handleMenuClose();
            history.push("/userProfile", { user: user.email });
          });
        }}
      >
        Mon compte
      </MenuItem>
      <MenuItem className={classes.menuItem} onClick={logout}>
        Déconnexion
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profil</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static" className={classes.appBar} elevation={0}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            aria-label="open drawer"
            onClick={() => {
              setIsLeftMenuOpen(true);
            }}
          >
            <MenuIcon />
          </IconButton>
          <Button
            className={classes.logoButton}
            disableRipple
            onClick={() => history.push("/home")}
          >
            <Typography className={classes.title} noWrap>
              LYBO
            </Typography>
          </Button>
          <div className={classes.grow} />
          <FormControl className={classes.formControl}>
            <Select
              value={selectedSalle}
              onChange={handleSalleChange}
              inputProps={{
                name: "salle",
                id: "salle-select",
              }}
              variant="standard"
              disableUnderline={false}
            >
              {salles.map((salle) => (
                <MenuItem key={salle.id} value={salle.id}>
                  {salle.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={classes.sectionDesktop}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              className={classes.accountButton}
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              className={classes.accountButton}
            >
              <MoreVert />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <LeftMenu open={isLeftMenuOpen} switchMenu={setIsLeftMenuOpen}></LeftMenu>
    </div>
  );
}
